define('app/nav/TenantDetails',['require','app/config/regions','app/config/states','app/config/categories','glu/itemView','app/models/Tenant','hbs!./TenantDetails.hbs'],function(require) {
	'use strict';
	var REGIONS = require('app/config/regions');
	var STATES = require('app/config/states');
	var CATEGORIES = require('app/config/categories');
	var ItemView = require('glu/itemView');
	var Tenant = require('app/models/Tenant');

	var view = ItemView.extend({

		template: require('hbs!./TenantDetails.hbs'),

		dialogTitle: 'Tenant Details',

		getClass: function() {
			return 'modal-tenant-details';
		},

		ui: {
			$tenantCode: '.tenant-code td.value',
			$tenantCategory: '.tenant-category td.value',
			$tenantRegion: '.tenant-region td.value',
			$tenantState: '.tenant-state td.value',
			$tenantAsset: '.tenant-asset td.value'
		},

		onRender: function() {
			var self = this;
			var tenant = new Tenant();
			tenant.fetch().done(function(response) {
				self.ui.$tenantCode.text(response.tenantId);
				self.ui.$tenantCategory.text(CATEGORIES[response.tenantCategory]);
				self.ui.$tenantRegion.text(REGIONS[response.region]);
				var state = STATES.US.find(function(st) {
					return st.value === response.state;
				});
				if (state) {
					self.ui.$tenantState.text(state.label);
				}
				if (response.assetSize) {
					var assetValue = response.assetSize;
					if (assetValue >= 1000.0) { // billion
						self.ui.$tenantAsset.text((assetValue / 1000.0) + ' Billion(s)');
					} else {
						self.ui.$tenantAsset.text((assetValue) + ' Million(s)');
					}
				}
			});
		},

		serializeData: function() {
			return this;
		}

	});

	return view;
});

